import { createContext, useContext } from 'react';

// The themed Select-style inputs render their dropdowns inline
// (withinPortal: false) so they stay inside GLASSMORPHISM cards and drawers.
// Inside a ThemedModal that clips them, because the modal content scrolls
// (overflow-y: auto) to keep tall forms reachable. ThemedModal provides `true`
// here so those inputs portal their dropdowns to <body> instead, where
// z-index 10000 puts them above the modal. See #1875.
export const DropdownPortalContext = createContext(false);

export const useDropdownWithinPortal = (): boolean => useContext(DropdownPortalContext);
